import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { FormBuilder} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../../environments/environment';

import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {ChucVu} from '../../../models/danhmuc/chucvu';
import {ChucVuService} from '../../../service/danhmuc/service-chucvu';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {EditDangKyPhongComponent} from '../phonghop/edit.component';
import {EditStaffsComponent} from './edit.component';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {ChuyenDonViComponent} from './chuyendv.component';

@Component({
  templateUrl: './staffs.component.html',
  encapsulation: ViewEncapsulation.None
})
export class StaffsComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public defaultValue: string[]=["-1"];
  public dataList: Staffs[];
  public srKeyword: string = '';
  public srDonViId: String = '-1';
  public srChucVu: number= -1;
  public dataChucVu: ChucVu[] = [];
  public slGroupId: string = "srGroupId";

  @ViewChild("selectGroup")
  public selectGroup: GroupInnerComponent;
  constructor( public staffsService: StaffsService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public chucVuService: ChucVuService,
               public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {

    this.chucVuService.getAll().subscribe(data=> this.dataChucVu = data);
    this.search();
  }
  search()
  {
    this.srDonViId= this.selectGroup!=null? this.selectGroup.selectTree.value.toString(): '-1';
    this.staffsService.findAllByPaging(this.srKeyword, this.srChucVu, (this.srDonViId!=''? this.srDonViId: '-1'), -1 , this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.staffsService.getCountByKeyword(this.srKeyword, this.srChucVu, (this.srDonViId!=''? this.srDonViId: '-1'), -1 ).subscribe(recordCount => this.totalItems = recordCount);
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  public deleteItem(id: number)
  {
    this.staffsService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  changeActive(id: number, active: number)
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
    active == 0? language.message_on_question : language.message_off_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.staffsService.changeActive(id, (active==1? 0: 1)).subscribe({
          next: () => {
            this.toastr.success(active == 0 ? language.message_on: language.message_off, language.message);
            this.search();


          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });


  }
  public edit(id: number): void {
    const modalEdit = this.bsModalService.show(EditStaffsComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditStaffsComponent>modalEdit.content).edit(
      id

    );
    (<EditStaffsComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  public chuyenDonVi(): void {
    const modalEdit = this.bsModalService.show(ChuyenDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ChuyenDonViComponent>modalEdit.content).showDonVi(


    );
    (<ChuyenDonViComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {


      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

